export default __webpack_public_path__ + "static/media/PlantillaPersonalInspeccion.1061dc18.png";